import TableCard from "components/Table/TableCard";
import ActionWrapper from "./ActionWrapper";
import BUMemberAssignmentFilter from "./Filter";
import PastNotesDetailModal from "./PastNotesDetailModal";

import { usePastNotesControllerContext } from "../../Controller";
import { useTranslationContext } from "context/TranslationContext";

const BUPastNotes = () => {
  const { t } = useTranslationContext();
  const {
    entityType,
    label,
    tab,
    pipelineSlug,
    selectedTab,
    selectedNote,
    searchParams,
    isLoadingGetNotes,
    pagination,
    fields,
    notes,
    onSearch,
    onSort,
    onChangeTab,
    onChangePerPage,
    onChangePage,
    onFilter,
    onCloseDetailModal,
  } = usePastNotesControllerContext();
  return (
    <>
      <TableCard
        title={label || t("past_notes")}
        action={
          <ActionWrapper
            keyword={searchParams?.filter?.keyword}
            onSearch={onSearch}
          >
            <BUMemberAssignmentFilter
              entityType={entityType}
              filter={searchParams?.filter}
              selectedTab={selectedTab}
              pipelineSlug={pipelineSlug}
              onFilter={onFilter}
            />
          </ActionWrapper>
        }
        keyId="idInsideSalesNotes"
        loading={isLoadingGetNotes}
        fields={fields || []}
        records={notes || []}
        tabs={tab}
        selectedTab={selectedTab}
        pagination={pagination}
        onChangePage={onChangePage}
        onChangePerPage={onChangePerPage}
        onSort={onSort}
        onChangeTab={onChangeTab}
      />
      <PastNotesDetailModal
        selectedNote={selectedNote}
        onCancel={onCloseDetailModal}
      />
    </>
  );
};

export default BUPastNotes;
